import React, { useState } from "react";
import axiosInstance from "../../axiosConfig";
import { Button } from "@mui/material";
import "filepond/dist/filepond.min.css";
import { RenderIf, Modal } from "@adl/smart-ui-library";

const FileUploadModal = ({ onCancel, metadata }) => {
  const [message, setMessage] = useState("");

  const [error, setError] = useState(false);

  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isUploading, setIsUploading] = React.useState<boolean>(false);

  const handleUpload = async () => {
    setIsUploading(true);
    try {
      const response = await axiosInstance.put(
        `documents/quick-sanitize`,
        metadata
      );
      setIsUploading(false);
      setUploadSuccess(true);
      setMessage("Document sanitised successfully!");
      return response;
    } catch (error) {
      setError(true);
      setMessage("Error");
    }
  };

  return (
    <Modal open={true} onClose={onCancel} name="quick-approval-confirmation">
      <Modal.Header>Quick Sanitise</Modal.Header>
      <Modal.Content>
        <div>
          {!error && !uploadSuccess ? (
            <div>
              <p>
                Are you sure you want to quick-sanitise this? <br />
                This will sanitise this document for Vault and mark it as Done.
              </p>
            </div>
          ) : (
            <p>{message}</p>
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <RenderIf isTrue={!error && !uploadSuccess}>
          <Button
            variant="outlined"
            disableElevation
            onClick={onCancel}
            sx={{ width: "100%" }}
          >
            Cancel
          </Button>
        </RenderIf>
        <RenderIf isTrue={error || uploadSuccess}>
          <Button
            variant="contained"
            disableElevation
            disabled={isUploading}
            onClick={onCancel}
            sx={{ width: "100%" }}
          >
            Okay
          </Button>
        </RenderIf>
        <RenderIf isTrue={!error && !uploadSuccess}>
          <Button
            variant="contained"
            disableElevation
            disabled={isUploading}
            onClick={handleUpload}
            sx={{ width: "100%" }}
          >
            Confirm
          </Button>
        </RenderIf>
      </Modal.Footer>
    </Modal>
  );
};

export default FileUploadModal;
